export default __webpack_public_path__ + "static/media/C280253.e441813c.jpg";